import React from 'react';
import AcompanhamentoForm from '../../../Cadastro/components/AcompanhamentoForm';
/**
 * Tab de detalhes do acompanhamento
 * Exibe o formulário em modo somente leitura
 */

const DetalhesTab = ({
  acompanhamentoId,
  onRefresh
}) => {
  return <AcompanhamentoForm acompanhamentoId={acompanhamentoId} isReadOnly={true} hideHeader={true} />;
};

export default DetalhesTab;
